import React from 'react'
import Layout from '../../Components/Common/Layout'
import Admin from './Admin'
import useSidebar from '../../Hooks/Sidebar'
import { Navigate, Route, Routes } from 'react-router-dom';


const Render = () => {
    const sidebarProps = useSidebar();
    if (!sidebarProps.user) {
        return <Navigate to={"/"} replace />;
    }
    return (
        <Layout {...sidebarProps} >
            <Routes>
                <Route path={sidebarProps.user.type + '/*'} element={sidebarProps.user.type === 'admin' ? <Admin /> : null} />
                <Route
                    path='*'
                    element={<Navigate to={"/panel/" + sidebarProps.user.type + '/'} replace />}
                />
            </Routes>
        </Layout >
    )
}


export default Render